moment = require('moment')
class UsageMonitorDirective
  constructor: ()->       
    class UsageMonitor      
      restrict: "AC"
      require: "^deviceUsage"
      controllerAs: "$monitor"
      scope: true
      controller: ($scope)->
        @labels = []
        @series = ["CPU Usage", "Memory Usage"]
        @data = [[], []]
        @options =
          legend:
            display: true
            position: "bottom"
            onClick: ()->
            
          scaleOverride : true
          scaleSteps : 5
          scaleStepWidth : 20
          scaleStartValue : 0
          animation: false
          lineTension: 0
          tooltips:
            enabled: true

        $scope.refresh = (usage)=>              
          {load, ram} = usage
          if load?
            usage = load.toFixed(2)
            free = 100 - usage
            time = moment().format("mm:ss")
            @labels.push(time)
            if usage > 100 then usage = 100
            @data[0].push(Number(usage))
            if @labels.length > 5
              @labels.splice(0, 1)
              @data[0].splice(0, 1)

          if ram?
            usage = (ram.total - ram.free) / ram.total * 100            
            if usage > 100 then usage = 100
            @data[1].push(Number(usage))
            if @data[1].length > 5
              @data[1].splice(0, 1)
        return @
      link: ($scope, $element, $attrs, $usage)->
        $usage.register (usage)=>          
          $scope.refresh(usage)

    return new UsageMonitor()

  
module.exports = UsageMonitorDirective


// WEBPACK FOOTER //
// ./src/component/device/usage/monitor/index.coffee